export interface IAddUserResponse {
    username: string | null;
}

export class AddUserResponse implements IAddUserResponse {
    public username: string | null;

    constructor(username: string | null){
        this.username = username;
    }
}